module.exports = __webpack_public_path__ + "static/img/newimg1.47de750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg1.png
// module id = kT5+
// module chunks = 1